export const PATH = {
  INDEX: '/'
}